"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiMooDropFill = function IconUiMooDropFill(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M15.281 40.789A13.249 13.249 0 0 0 24 43.869c.51 0 1-.018 1.5-.057a13.434 13.434 0 0 0 8.373-4.068 13.445 13.445 0 0 0 4.074-9.823 13.289 13.289 0 0 0-1.659-6.61c-.161-.321-1.52-2.716-11.425-19.736a1.04 1.04 0 0 0-1.728 0c-9.9 17.02-11.264 19.415-11.4 19.691a13.335 13.335 0 0 0-1.684 6.655 13.445 13.445 0 0 0 4.074 9.823 15.557 15.557 0 0 0 1.156 1.045z"
  }));
};

IconUiMooDropFill.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiMooDropFill;
exports.default = _default;